import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
        if (window.location.pathname !== "/login") window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default api;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(", ");
  if (d && typeof d.msg === "string") return d.msg;
  return e?.message || "Something went wrong";
};

export const fmtDate = (d) => (d ? new Date(d + "T00:00:00").toLocaleDateString("en-GB") : "—");

export const daysLeft = (d) => {
  if (!d) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return Math.round((new Date(d + "T00:00:00") - today) / 86400000);
};

export const dueClass = (d) => {
  const n = daysLeft(d);
  if (n === null) return "text-muted-foreground/60";
  if (n <= 7) return "text-[#FF3B30] font-bold";
  if (n <= 14) return "text-amber-600 dark:text-[#FFD60A] font-bold";
  return "text-emerald-600 dark:text-[#32D74B]";
};

export const fmtDist = (m) => `${(m / 1609.34).toFixed(1)} mi`;
export const fmtDur = (s) => {
  const h = Math.floor(s / 3600);
  const min = Math.round((s % 3600) / 60);
  return h > 0 ? `${h}h ${min}m` : `${min}m`;
};
